var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTempleLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9375 2.75C19.9375 2.3703 19.6297 2.0625 19.25 2.0625H11.0038C10.6241 2.0625 10.3163 2.3703 10.3163 2.75C10.3163 3.1297 10.6241 3.4375 11.0038 3.4375H18.5625V18.5625H11C10.6203 18.5625 10.3125 18.8703 10.3125 19.25C10.3125 19.6297 10.6203 19.9375 11 19.9375H19.25C19.6297 19.9375 19.9375 19.6297 19.9375 19.25V2.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36114 6.38886C7.09265 6.12038 6.65735 6.12038 6.38886 6.38886L2.26386 10.5139C1.99538 10.7823 1.99538 11.2177 2.26386 11.4861L6.38886 15.6111C6.65735 15.8796 7.09265 15.8796 7.36114 15.6111C7.62962 15.3427 7.62962 14.9073 7.36114 14.6389L3.72227 11L7.36114 7.36114C7.62962 7.09265 7.62962 6.65735 7.36114 6.38886Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3545 10.9961C15.3545 10.6164 15.0467 10.3086 14.667 10.3086H2.75033C2.37063 10.3086 2.06283 10.6164 2.06283 10.9961C2.06283 11.3758 2.37063 11.6836 2.75033 11.6836H14.667C15.0467 11.6836 15.3545 11.3758 15.3545 10.9961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempleLogout);
export default __webpack_public_path__ + "static/media/temple-logout.1ae68203c94a26177f6f00fcc5575b28.svg";
export { ForwardRef as ReactComponent };